export function getCssVar(name: string, fallback: string): string {
    const value = getComputedStyle(document.documentElement).getPropertyValue(name)?.trim();
    return value || fallback;
}

export function getButtonColorDefaults() {
    return {
        light: {
            background: getCssVar('--accentLight', getCssVar('--accent', '#FF5E38')),
            border: getCssVar('--accentLight', getCssVar('--accent', '#FF5E38')),
            primary: getCssVar('--primaryLight', getCssVar('--pureWhite', '#fefefe')),
        },
        dark: {
            background: getCssVar('--accentDark', getCssVar('--accent', '#FF5E38')),
            border: getCssVar('--accentDark', getCssVar('--accent', '#FF5E38')),
            primary: getCssVar('--primaryDark', getCssVar('--pureWhite', '#fefefe')),
        }
    };
}